import React from 'react';
import styled from 'styled-components';
import { Lista } from './lista';
import { Collapse as AntdCollapse, Icon } from 'antd';

const Collapse = styled(AntdCollapse)`
    line-height: normal;
   && .ant-collapse-content-box {
       padding: 0;
       margin-bottom: 0;
       margin-top: 0
   }
`;

const Panel = styled(Collapse.Panel)`
    && {
        border: 0;
        overflow: hidden;
    }
`;

const P = styled.p`
    display: flex;
    align-self: center;
    justify-content: center;
    color: #969696;
    font-weight: lighter;
`;

const ConversationList = ({
    style,
    header,
    conversations = [],
    renderItem,
    panelKey,
    open,
    ...props
}) => { 
    return(
        <Collapse
            style={{ padding: 0 }}
            bordered={false}
            defaultActiveKey={open? [panelKey] : null }
            expandIcon={({ isActive }) =>
                isActive ? (
                    <Icon type="minus-circle" style={{ fontSize: 20, color: '#969696' }} />
                ) : (
                        <Icon type="plus-circle" style={{ fontSize: 20, color: '#969696' }} />
                    )
            }
            expandIconPosition="right"
        >
            <Panel
                header={header}
                key={panelKey}
                style={style}
            >
                {conversations.length > 0 ?
                    <Lista
                        data={conversations}
                        renderItem={renderItem}
                    />
                :
                    <div>
                         <P>Nenhuma conversa</P>
                    </div>
                }
            </Panel>
        </Collapse>
    )}

export default ConversationList;


// WEBPACK FOOTER //
// ./src/components/ConversationList.js